import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";

import { MIN_DESKTOP_WIDTH } from "commons/src/NucleusTheme";
import { isPrintMode } from "commons/src/QueryParameter";

import { setMsg } from "../reducers/applicationContextActions";
import { INFO } from "../helpers/ErrorHelpers";
import { Message } from "./Message";

function GlobalMsgComponent({ isRedirect, dispatch, msg, fullWidth, severity, errorCode }) {
    useEffect(() => {
        return () => !isRedirect && !isPrintMode() && dispatch(setMsg(""));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (msg && window.innerWidth < MIN_DESKTOP_WIDTH) {
            window.scrollTo(0, 0);
        }
    }, [msg]);

    return (
        <Container data-testid="global-msg" fullWidth={fullWidth}>
            <Message
                marginTop="15px"
                severity={severity}
                text={msg}
                errorCode={errorCode}
                shown={!!msg}
            />
        </Container>
    );
}

const Container = styled.div`
    width: ${props => (props.fullWidth ? "100%" : "400px")};

    @media (max-width: ${props => props.theme.maxWidth}) {
        width: 100%;
        max-width: ${props => (props.fullWidth ? "100%" : "400px")};
    }
`;

GlobalMsgComponent.propTypes = {
    dispatch: PropTypes.func,
    msg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    severity: PropTypes.string,
    errorCode: PropTypes.string,
    isRedirect: PropTypes.bool,
    fullWidth: PropTypes.bool
};

const mapStateToProps = state => ({
    msg: state.applicationContext.msg,
    severity: state.applicationContext.msgSeverity || INFO,
    errorCode: state.applicationContext.errorCode,
    isRedirect: !!state?.navigation?.path
});

export const GlobalMsg = connect(mapStateToProps)(GlobalMsgComponent);
